import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from '@/functions/Util';
import * as InscricaoEstadual from '@/functions/IEValidation';

export default class ClienteValidation extends DefaultValidation {
    constructor(msgs) {
        super(msgs);
    }
    validate(model, refs) {
        let validated = true;

        if (Util.isNull(model.idlpserp)) {
            refs.idlpserp.focusedOut = true;
            validated = false;
        }

        if (Util.isNull(model.nome)) {
            refs.nomeInput.focusedOut = true;
            validated = false;
        }

        if (Util.isNull(model.rsocial)) {
            refs.rsInput.focusedOut = true;
            validated = false;
        }

        if (Util.isNull(model.idcidade)) {
            refs.cidadeInput.focusedOut = true;
            validated = false;
        }

        if (Util.isNull(model.idregiao)) {
            refs.regiaoSelect.focusedOut = true;
            validated = false;
        }

        if (Util.isNull(model.idbandeira)) {
            refs.bandeiraInput.focusedOut = true;
            validated = false;
        }

        if (Util.isNull(model.endereco)) {
            refs.enderecoInput.focusedOut = true;
            validated = false;
        }

        if (Util.isNull(model.bairro)) {
            refs.bairroInput.focusedOut = true;
            validated = false;
        }

        if (
            Util.isNull(model.cnpj) ||
            (!Util.isNull(model.cnpj) && !Util.validateCnpj(model.cnpj))
        ) {
            refs.cnpjInput.focusedOut = true;
            validated = false;
        }

        if (
            Util.isNull(model.latitude) ||
            (!Util.isNull(model.latitude) && !Util.validateLatitude(model.latitude))
        ) {
            refs.latitude.focusedOut = true;
            validated = false;
        }

        if (
            Util.isNull(model.longitude) ||
            (!Util.isNull(model.longitude) && !Util.validateLongitude(model.longitude))
        ) {
            refs.longitude.focusedOut = true;
            validated = false;
        }

        if (!Util.isNull(model.email) && !Util.validateEmail(model.email)) {
            refs.emailInput.focusedOut = true;
            validated = false;
        }

        if (!Util.isNull(model.telefone) && !Util.validatePhone(model.telefone)) {
            refs.telefoneInput.focusedOut = true;
            validated = false;
        }

        if (!Util.isNull(model.fax) && !Util.validatePhone(model.fax)) {
            refs.faxInput.focusedOut = true;
            validated = false;
        }

        if (!Util.isNull(model.celular) && !Util.validatePhone(model.celular)) {
            refs.celularInput.focusedOut = true;
            validated = false;
        }

        if (Util.isNull(model.cep) || (!Util.isNull(model.cep) && !Util.validateCEP(model.cep))) {
            refs.cepInput.focusedOut = true;
            validated = false;
        }

        return validated;
    }
}
